"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditDistributor = void 0;
const filter_bar_1 = require("client/components/filter-bar");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const text_field_1 = require("client/components/material/text-field");
const ui_1 = require("client/components/ui");
const callable_1 = require("client/components/ui/callable");
const store_1 = require("client/modules/inventory-order/store");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const Collapse_1 = require("material-ui/transitions/Collapse");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./edit-distributor.less");
const columns = [
    // {
    //   label: " ",
    //   id: "placeholder",
    //   className: "placeholder"
    // },
    { label: "id", id: "id" },
    {
        label: "distributor name",
        id: "distributor"
    },
    {
        label: "account number",
        id: "account"
    }
];
let EditDistributor = class EditDistributor extends react_1.Component {
    constructor() {
        super(...arguments);
        this.currentRowIndex = -1;
        this.checkedAll = false;
        this.checkedBoxes = new Map();
        this.checkedBoxesOriginal = new Map();
        // public checkedBoxes: { [key: number]: boolean } = {};
        this.showChildren = new Map();
        this.loading = false;
        this.error = "";
        this.order = "ASC";
        this.orderBy = "package";
        this.filterText = "";
        this.siteDistributors = new Map();
        this.siteDistributorsOriginal = new Map();
        this.handleCheckRow = (row, index) => {
            this.checkedBoxes.set(row.id, !this.checkedBoxes.get(row.id));
            this.showChildren.set(row.id, this.checkedBoxes.get(row.id) ? true : false);
            if (this.isChanged()) {
                this.status = ui_1.FormStatus.Dirty;
            }
            else {
                this.status = this.props.status;
            }
        };
        this.renderListRows = (child, index) => {
            const className = this.currentRowIndex === index
                ? "list-component__row edit-active"
                : "list-component__row edit-inactive";
            return (React.createElement(React.Fragment, { key: index },
                React.createElement(list_item_1.MaterialListItem, { className: className, onClick: () => this.handleClickRow(child) },
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement(React.Fragment, null,
                            React.createElement(checkbox_1.MaterialCheckbox, { checked: this.checkedBoxes.get(child.id) || false, label: "", onAction: () => this.handleCheckRow(child, index) }),
                            child.id) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: child.distributor }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: this.siteDistributors.has(child.id)
                            ? this.siteDistributors.get(child.id).accountNumber
                            : "" })),
                React.createElement(Collapse_1.default, { in: this.showChildren.get(child.id) || false },
                    React.createElement("div", { className: "edit-inventorysite", key: -1 },
                        React.createElement("div", { className: "list-component__row" }, this.renderRow(child))))));
        };
        this.handleClickRow = (row) => {
            this.showChildren.set(row.id, !this.showChildren.get(row.id));
        };
        this.renderRow = (distributor) => (React.createElement("div", { className: "main" },
            React.createElement("div", { className: "site-name" },
                React.createElement("h3", null, distributor.distributor),
                React.createElement("h4", null,
                    distributor.distributor,
                    " | ",
                    distributor.distributor)),
            React.createElement("div", { className: "inventorysite-info" },
                React.createElement("div", { className: "row" },
                    React.createElement(text_field_1.MaterialTextField, { className: "material-text-field-account-number", label: "account number", onChange: this.handleChangeString("accountNumber", distributor), required: this.checkedBoxes.has(distributor.id) &&
                            this.checkedBoxes.get(distributor.id), type: "text", value: this.siteDistributors.has(distributor.id)
                            ? this.siteDistributors.get(distributor.id).accountNumber
                            : "" })),
                React.createElement("div", { className: "inventorysite-info__buttons" },
                    React.createElement(button_1.MaterialButton, { className: "btnCancelRow", onClick: this.handleCancelRow }, "Cancel"),
                    React.createElement(button_1.MaterialButton, { onClick: this.handleSaveRow, className: `button-status-${this.status}`, primary: true }, this.status === ui_1.FormStatus.Saved ? "Saved" : "Save")))));
        this.handleChangeString = (fieldName, distributor) => (event, value) => {
            if (this.siteDistributors.has(distributor.id)) {
                const siteDistributor = this.siteDistributors.get(distributor.id);
                siteDistributor.accountNumber = value;
                this.siteDistributors.set(distributor.id, siteDistributor);
            }
            if (this.isChanged()) {
                this.status = ui_1.FormStatus.Dirty;
            }
            else {
                // this.status = FormStatus.Clean;
                this.status = this.props.status;
            }
        };
        this.handleCheckAll = () => {
            if (this.checkedAll) {
                this.checkedBoxes.clear();
            }
            else {
                store_1.inventoryOrderStore.distributors &&
                    store_1.inventoryOrderStore.distributors.map(distributor => {
                        this.checkedBoxes.set(distributor.id, true);
                    });
            }
            this.checkedAll = !this.checkedAll;
            if (this.isChanged()) {
                this.status = ui_1.FormStatus.Dirty;
            }
        };
        this.renderForm = () => (React.createElement(ui_1.UiForm, { buttons: [
                React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
                "Save"
            ], loading: this.loading, isChanged: this.isChanged, status: this.status, saved: "Saved", onSubmit: this.handleSubmit, error: this.error },
            React.createElement("div", { className: "inventory__list" }, this.renderDistributorList())));
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            // this.loadInventory();
        };
        this.isChanged = () => {
            const site = store_2.sitesDetailStore.site.value;
            if (!site) {
                return false;
            }
            const multiSelections = [];
            for (const [key, value] of this.checkedBoxes) {
                if (value) {
                    multiSelections.push(String(key));
                }
            }
            let accountNumberChanged = false;
            let newSelect = false;
            for (const [key, isChecked] of this.checkedBoxes) {
                const isCheckedOriginal = this.checkedBoxesOriginal.get(key);
                if (isChecked !== isCheckedOriginal) {
                    newSelect = true;
                    break;
                }
                // If checked
                if (isChecked) {
                    const original = this.siteDistributorsOriginal.get(key);
                    const current = this.siteDistributors.get(key);
                    // console.log("original", key, original ? original.accountNumber : "n/a");
                    // console.log("current", key, current ? current.accountNumber : "n/a");
                    if (original &&
                        current &&
                        original.accountNumber !== current.accountNumber) {
                        accountNumberChanged = true;
                        break;
                    }
                }
            }
            return accountNumberChanged || newSelect;
        };
        this.handleCancel = () => {
            this.props.onCancel();
        };
        this.handleCancelRow = () => {
            // this.updateInventorySites();
        };
        this.handleSaveRow = () => {
            this.handleSubmit();
        };
        this.onCallback = (value) => {
            this.filterText = value;
            // this.loadInventory();
        };
        this.handleSubmit = () => {
            if (!this.props.site)
                return;
            const multiSelections = [];
            for (const [key, value] of this.checkedBoxes) {
                if (value) {
                    multiSelections.push(String(key));
                }
            }
            const siteDistributorsToSubmit = [];
            for (const [key, value] of this.siteDistributors) {
                if (multiSelections.includes(String(key))) {
                    siteDistributorsToSubmit.push(value);
                }
            }
            callable_1.callable(this.props.onSave)(this.props.site, siteDistributorsToSubmit);
        };
    }
    componentWillMount() {
        this.loading = this.props.loading;
        this.error = this.props.error;
    }
    async componentDidMount() {
        await store_1.inventoryOrderStore.listDistributors();
        this.initializeSiteDistributors();
    }
    componentWillReceiveProps(props) {
        this.initializeSiteDistributors();
        this.loading = props.loading;
        this.status = props.status;
        this.error = props.error;
    }
    render() {
        return (React.createElement("div", { className: "site-edit-inventory" },
            this.renderFilter(),
            this.renderForm()));
    }
    initializeSiteDistributors() {
        // clear collections before reinitializing.
        this.siteDistributors.clear();
        this.siteDistributorsOriginal.clear();
        const { value: siteDistributors } = store_2.sitesDetailStore.siteDistributors;
        const distributors = store_1.inventoryOrderStore.distributors;
        // Init data from db
        for (const siteDistributor of siteDistributors) {
            this.siteDistributors.set(siteDistributor.distributor.id, Object.assign({}, siteDistributor));
            this.siteDistributorsOriginal.set(siteDistributor.distributor.id, Object.assign({}, siteDistributor));
            if (!siteDistributor.deletedAt) {
                this.checkedBoxes.set(siteDistributor.distributor.id, true);
            }
            else {
                this.checkedBoxes.set(siteDistributor.distributor.id, false);
            }
        }
        // Add filler data
        for (const distributor of distributors) {
            if (!this.siteDistributors.has(distributor.id)) {
                this.siteDistributors.set(distributor.id, {
                    accountNumber: "",
                    distributor
                });
                this.siteDistributorsOriginal.set(distributor.id, {
                    accountNumber: "",
                    distributor
                });
                this.checkedBoxes.set(distributor.id, false);
            }
            this.showChildren.set(distributor.id, false);
        }
        // Set original checkboxes
        this.checkedBoxesOriginal = new Map(this.checkedBoxes);
        // Make a copy to track original
        // this.siteDistributorsOriginal = new Map(this.siteDistributors);
    }
    renderDistributorList() {
        const distributors = store_1.inventoryOrderStore.distributors;
        return (React.createElement(list_1.MaterialList, { checkbox: this.renderCheckAll(), columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: distributors, renderRow: this.renderListRows, resizableheader: true, customClass: "custom-material-list__site-distributors-list" }));
    }
    renderCheckAll() {
        return (React.createElement(checkbox_1.MaterialCheckbox, { onAction: this.handleCheckAll, label: "", checked: this.checkedAll, indeterminate: false }));
    }
    renderFilter() {
        return (React.createElement("div", { className: "inventory__filter" },
            React.createElement(filter_bar_1.FilterBar, { callBack: this.onCallback, filterText: this.filterText })));
    }
};
__decorate([
    mobx_1.observable
], EditDistributor.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], EditDistributor.prototype, "checkedAll", void 0);
__decorate([
    mobx_1.observable
], EditDistributor.prototype, "checkedBoxes", void 0);
__decorate([
    mobx_1.observable
], EditDistributor.prototype, "checkedBoxesOriginal", void 0);
__decorate([
    mobx_1.observable
], EditDistributor.prototype, "showChildren", void 0);
__decorate([
    mobx_1.observable
], EditDistributor.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], EditDistributor.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], EditDistributor.prototype, "error", void 0);
__decorate([
    mobx_1.observable
], EditDistributor.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EditDistributor.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EditDistributor.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EditDistributor.prototype, "siteDistributors", void 0);
__decorate([
    mobx_1.observable
], EditDistributor.prototype, "siteDistributorsOriginal", void 0);
EditDistributor = __decorate([
    mobx_react_1.observer
], EditDistributor);
exports.EditDistributor = EditDistributor;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/components/edit-distributor/edit-distributor.tsx
// module id = 4027
// module chunks = 0